/**
 * TMR Unique Key directive
 *
 * Adds a validator callback to the model that checks if the value entered in
 * an input field is unique among the values passed for reference.
 *
 * The passed values can be an array or an object. If it's an object, the unique
 * values checked are its properties.
 *
 * The callback may be used by ng-message or other components.
 *
 * @example <caption>myInput is valid if myKey is unique among listOfKeys</caption>
 * <input name="myInput" ng-model="$ctrl.myKey" tmr-unique-key="$ctrl.listOfKeys">
 * <div ng-messages="myFormController.myInput.$error">
 *   <div ng-message="tmrUniqueKey" translate>MYMESSAGE</div>
 * </div>
 *
 * @namespace
 * @alias tmrUniqueKey
 * @type {ngDirective}
 */
function tmrUniqueKeyDirective($parse) {
  'ngInject'
  return {
    require: 'ngModel',
    link,
  }

  function link(scope, elm, attrs, ctrl) {
    ctrl.$validators.tmrUniqueKey = tmrUniqueKey
    let fn = $parse(attrs.tmrUniqueKey)

    function tmrUniqueKey(modelValue) {
      let values = fn(scope) || []
      if (!Array.isArray(values) && typeof values === 'object') {
        // List is object
        values = Object.keys(values)
      }
      return ctrl.$isEmpty(modelValue) || values.indexOf(modelValue) == -1
    }
  }
}

export const directive = ['tmrUniqueKey', tmrUniqueKeyDirective]
